import { DestinationAccountControllerType } from "../useDestinationAccount";

import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { TitleLarge } from "../../../components/font";
import { OptionTile } from "@manifesthhqinc/ui-library";
import { OptionTileContainer } from "../../henry-questionniare/screens/styles";
import { STEP_DESTINATION_CONNECT_IRA, STEP_DESTINATION_EXPLORE_IRA } from "../../../class/transferDetails";
import HeadingContainer from "../../../layout/heading-container";
import Analytics from "../../../utils/productAnalytics";

const ConnectIRAType = (props: DestinationAccountControllerType) => {
  const { goToScreen } = props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name="confirm-destination-account">
        <Container>
          <HeadingContainer paneVariant="optionForm" withProgressBar>
            <TitleLarge $textAlign="left">Do you have an IRA you want to transfer into?</TitleLarge>
          </HeadingContainer>
          <OptionTileContainer>
            <OptionTile
              appearance="secondary"
              variant="clickthrough"
              onClick={() => goToScreen(STEP_DESTINATION_CONNECT_IRA)}
            >
              Add an IRA account
            </OptionTile>
            <OptionTile
              appearance="secondary"
              variant="clickthrough"
              onClick={() => {
                Analytics.track({ name: "Clicked Explore IRA options" });
                goToScreen(STEP_DESTINATION_EXPLORE_IRA);
              }}
            >
              Explore IRA options
            </OptionTile>
          </OptionTileContainer>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};

export default ConnectIRAType;
